import React from "react";
import { Navbar, Footer, StyleSwitcher } from "./components";
import ConfigRoutes from "./ConfigRoutes";
import PartnersCarousel from "./components/carousel/PartnersCarousel";

const App = () => {
  return (
    <div className="main-wrapper">
      <Navbar />
      <ConfigRoutes />
      <PartnersCarousel />
      <Footer />
      <StyleSwitcher />
    </div>
  );
};

export default App;
